import { Component, EventEmitter, Input, Output } from '@angular/core';

type TableDataValues =  string | number | Date | boolean

 type TableDataItem = Record<string , TableDataValues>



export type TableColumn = {
  key: string;
  name: string;
  type?: 'value' | 'check' | 'btn';
  checkOptions?: {
    unique?: boolean // se tabela só permite uma linha marcada por vez nessa coluna, padrao = true
  },
  witdh? : number
}

@Component({
  selector: 'app-table-for-filter',
  templateUrl: './table-for-filter.component.html',
  styleUrls: ['./table-for-filter.component.scss']
})
export class TableForFilterComponent {

  @Input() data: TableDataItem[] = [];
  @Input() columns : TableColumn[] = [];
  @Input() showHeader: boolean = true;
  @Input() showBorder : boolean = true;

  @Output() checked = new EventEmitter<TableDataItem>();


  ngOnInit(): void {

  }

  _checked(x : TableDataItem, y : TableColumn , dataItemIndex: number) {
    if (y.checkOptions?.unique ?? true) {
      this.data
        .filter( (val , i) => i != dataItemIndex )
        .forEach( item => {
          item[y.key] = false;
        })
    }
    this.checked.emit(x)
  }

}
